export function setActiveMapStyle(state, styleId) {
    state.activeMapStyle = styleId;
}

export function setMapTraffic(state, payload) {
    state.mapTraffic = payload;
}

export function setMapTrafficFromUrl(state, payload) {
    state.mapTrafficFromUrl = payload;
}

export function setMapBounds(state, payload) {
    state.mapBounds = payload
}

export function setPinDropLoading(state, payload) {
    state.pinDrop.loading = payload
}

export function setPinDropData(state, payload) {
    state.pinDrop.data = payload
}

export function setMapMoved(state, payload) {
    state.mapMoved = payload
}

export function setMapLoaded(state, payload) {
    state.mapLoaded = payload
}

export function setUserLocationLoaded(state, payload) {
    state.userLocationLoaded = payload
}

export function setMapGlSupported(state, payload) {
    state.mapGlSupported = payload
}

export function setMapZoom(state, payload) {
    state.mapZoom = payload
}
